import React, { useEffect, useMemo } from 'react';

import Aos from 'aos';
import 'aos/dist/aos.css';

const SectionSchedule = ({ theme }) => {
  const datas = [
    {
      id: '1',
      day: 'Dia 01',
      date: '11/12/2020',
      speakers: [
        {
          hora: '09h00',
          name: 'Dr Evan S. Dellon',
          picture:
            'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          profission: 'Gastroenterologista',
          descriptionH3: 'Algum Titulo Aqui',
          descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
        {
          hora: '09h00',
          name: 'Dr Evan S. Dellon',
          picture:
            'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          profission: 'Gastroenterologista',
          descriptionH3: 'Algum Titulo Aqui',
          descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
        {
          hora: '09h00',
          name: 'Dr Evan S. Dellon',
          picture:
            'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          profission: 'Gastroenterologista',
          descriptionH3: 'Algum Titulo Aqui',
          descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
      ],
    },
    {
      id: '2',
      day: 'Dia 02',
      date: '11/12/2020',
      speakers: [
        {
          hora: '12h00',
          name: 'Rosa Gama',
          picture:
            'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          profission: 'Medico',
          descriptionH3: 'Algum Titulo Aqui',
          descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
        {
          hora: '13h00',
          name: 'Denise Leonor',
          picture:
            'https://firebasestorage.googleapis.com/v0/b/rstcom20.appspot.com/o/companies%2Fnovalp%2Flp%2Fteam%2F4.jpg?alt=media&token=d25620ff-1d28-4adc-be81-3acea8236a34',
          profission: 'Medico',
          descriptionH3: 'Algum Titulo Aqui',
          descriptionP: 'Gastroenterologista acadêmico com treinamento formal em pesquisa em epidemiologia, pesquisa clínica e translacional, e desenho de ensaios clínicos. É responsável por uma pesquisa que se concentra em otimizar o diagnóstico, caracterizar a epidemiologia, estudar a patogênese e refinar o tratamento e o monitoramento de EEo, com o objetivo geral de melhorar o atendimento ao paciente e os resultados em EoE. É especialista reconhecido internacionalmente em esôfago eosinofílico.',
        },
      ],
    },
  ];

  function Tab({ data }) {
    const [visibleTab, setVisibleTab] = React.useState(data[0].id);

    const listTitles = useMemo(
      () =>
        data.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => setVisibleTab(item.id)}
            className={
              visibleTab === item.id
                ? 'tab-title tab-title--active'
                : 'tab-title'
            }
          >
            <h3>{item.day}</h3>
            <h4>{item.date}</h4>
          </button>
        )),
      [data, visibleTab]
    );

    const listContent = data.map((item) => (
      <div
        key={`${item.id}${Math.random()}`}
        style={visibleTab === item.id ? {} : { display: 'none' }}
        className="tab-pane active"
        role="tabpanel"
        aria-labelledby="nav-home-tab"
      >
        {item.speakers.map((speaker) => (
          <div
            key={`${speaker.id}${Math.random()}`}
            className="tab_single_content"
          >
            <div className="row">
              <div className="col-md-12">
                <div className="schedule-listing">
                  <div className="schedule-item">
                    <div className="sc-time">{speaker.hora}</div>
                    <div className="sc-pic">
                      <img
                        src={speaker.picture}
                        className="img-circle"
                        alt=""
                      />
                    </div>
                    <div className="sc-name">
                      <h4>{speaker.name}</h4>
                      <span>{speaker.profission}</span>
                    </div>
                    <div className="sc-info">
                      <h3>{speaker.descriptionH3}</h3>
                      <p>{speaker.descriptionP}</p>
                    </div>
                    <div className="clearfix" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ));

    return (
      <div className="de_tab tab_style_4 text-center">
        <ul className="de_nav de_nav_dark">{listTitles}</ul>
        <div className="de_tab_content text-left">{listContent}</div>
      </div>
    );
  }

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <>
      {/* section begin */}

      <section
        id="section-schedule"
        className={theme ? 'dark-mode' : 'light-mode'}
        aria-label="section-services-tab"
      >
        <div className="wm wm-border light" data-aos="fade-down">
          agenda
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-6 offset-md-3 text-center">
              <h1 data-aos="fade-up">Agenda</h1>
              <div className="separator">
                <span>
                  <i className="fa fa-square" />
                </span>
              </div>
              <div className="spacer-single" />
            </div>
            <div className="col-md-12">
              <Tab data={datas} />
            </div>
          </div>
        </div>
      </section>
      {/* section close */}
    </>
  );
};

export default SectionSchedule;
